// tslint:disable
import { get } from 'lodash';
import * as React from 'react';
import { InputField } from '../../components/fields/input.field';
import { ConsoleLib } from '../../components/libs/console.lib';
import { ListResourceLoader } from '../../components/libs/list-resource-loader';
import { ListLib } from '../../components/libs/list.lib';
import { ListConsole } from '../../components/structurals/list-console';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { Pagination } from '../../components/structurals/pagination';
import { ListActions, ListResponsePresenterTable } from '../../components/structurals/presenters/list-response-presenter-table';

export class DefaultFaqList extends React.Component<any, any> {

    render() {
        return (
            <ListResourceLoader entity='faq' render={(list: ListLib) => {
                return <div>
                    <div id="page-title">
                        <h2>Company FAQs</h2>
                        <p>Lorem</p>
                    </div>
                    <div className="row flex-sm-row-reverse">
                        <ListConsole className="col-md-3 col-xs-12 pull-right relative" config={list.console} render={(console: ConsoleLib) => <div>
                            <InputField field={console.setQuery('_keyword', {'title': 'Page title'})}/>
                        </div>}/>

                        <div className='col-xs-12 col-lg-9 pull-left relative'>
                            <LoaderComponent isLoading$={list.isLoading$}/>
                            <ListResponsePresenterTable
                                head={() => this.head()}
                                row={(item: any, index: number, actions: ListActions) => this.row(item, index, actions, list)}
                                items={list.member}/>

                            <Pagination config={list.pagination}/>

                        </div>

                    </div>
                </div>;
            }}/>

        );
    }

    private async handleDelete(item: any, list: ListLib, ListActions: ListActions, event: any) {
        event.preventDefault();
        event.stopPropagation();

        try {
            list.isLoading$.next(true);
            await ListActions.delete(item['@id']);
        } catch (error) {

        } finally {
            list.refetch();
        }
    }

    private head() {
        return <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Action</th>
        </tr>;
    }

    private row(item: any, index: number, actions: ListActions, list: ListLib) {
        return <tr key={index}>
            <td>{get(item, 'id', '-')}</td>
            <td>{get(item, 'title', 'N/A')}</td>
            <td>
                <div className="btn-group btn-group-sm">
                    <button className="btn btn-xs btn-primary" onClick={() => actions.open(item['@id'])}>Edit content</button>
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li>
                            <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                Delete page
                            </a>
                        </li>
                    </ul>
                </div>
            </td>
        </tr>;
    }
}



// WEBPACK FOOTER //
// ./src/__templates/lists/default.faq.list.tsx